import { OrderItemInfo, ProlongationInfo } from 'appTypes/orders'

export const sortProlongations = (orderItemInfo: OrderItemInfo): ProlongationInfo[] =>
  [...orderItemInfo.prolongations].sort((a, b) => b.prolongation.id - a.prolongation.id)
